// Anonymous visitor tracking — records page views on both public and app routes.
// Uses a client-side session UUID (localStorage) and dedupes rapid re-fires per path.
import { api } from "@/lib/api";

const STORAGE_KEY = "boxeb2b_visitor_sid";
const LAST_PATH_KEY = "boxeb2b_visitor_last_path";
const LAST_TS_KEY = "boxeb2b_visitor_last_ts";
const DEDUPE_MS = 3000; // don't fire twice for same path within 3s

function uuid() {
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
    return "sid-" + Math.random().toString(36).slice(2) + "-" + Date.now().toString(36);
}

function getSessionId() {
    if (typeof window === "undefined") return "server";
    let sid = localStorage.getItem(STORAGE_KEY);
    if (!sid) {
        sid = uuid();
        try { localStorage.setItem(STORAGE_KEY, sid); } catch (_e) { /* ignore */ }
    }
    return sid;
}

export function trackPageview(path) {
    if (typeof window === "undefined") return;
    try {
        const now = Date.now();
        const lastPath = sessionStorage.getItem(LAST_PATH_KEY);
        const lastTs = parseInt(sessionStorage.getItem(LAST_TS_KEY) || "0", 10);
        if (lastPath === path && now - lastTs < DEDUPE_MS) return; // dedupe
        sessionStorage.setItem(LAST_PATH_KEY, path);
        sessionStorage.setItem(LAST_TS_KEY, String(now));
    } catch (_e) { /* private mode — track anyway */ }

    const payload = {
        path: path.slice(0, 512),
        referrer: document.referrer ? document.referrer.slice(0, 512) : null,
        session_id: getSessionId(),
        viewport: `${window.innerWidth}x${window.innerHeight}`,
        locale: navigator.language || null,
    };
    // Fire and forget — never block navigation on tracking.
    api.post("/visits/track", payload).catch(() => { /* ignore */ });
}
